import React from 'react';
import Hero from './Hero';
import HowItWorks from './HowItWorks';
import Benefits from './Benefits';
import Statistics from './Statistics';
import Testimonials from './Testimonials';
import News from './News';

function Solutions() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <Testimonials />
      <Statistics />
      <Benefits />
      <News />
    </>
  );
}

export default Solutions;